var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LifiErrorCode, TransactionError } from '../utils/errors';
import { getSlippageNotMetMessage } from '../utils/parseError';
import { updatedStepMeetsSlippageConditions } from './utils';
/**
 * This method checks whether the new and updated Step meets the required slippage conditions.
 * If yes it returns the updated Step.
 * If no and if user interaction is allowed it triggers the acceptSlippageUpdateHook. If no user interaction is allowed it aborts.
 *
 * @param statusManager
 * @param oldStep
 * @param newStep
 * @param acceptSlippageUpdateHook
 * @param allowUserInteraction
 */
export const stepComparison = (statusManager, oldStep, newStep, acceptSlippageUpdateHook, allowUserInteraction) => __awaiter(void 0, void 0, void 0, function* () {
    if (updatedStepMeetsSlippageConditions(oldStep, newStep)) {
        return statusManager.updateStepInRoute(newStep);
    }
    let allowStepUpdate;
    if (allowUserInteraction) {
        allowStepUpdate = yield acceptSlippageUpdateHook({
            oldToAmount: oldStep.estimate.toAmount,
            newToAmount: newStep.estimate.toAmount,
            toToken: newStep.action.toToken,
            oldSlippage: oldStep.action.slippage,
            newSlippage: newStep.action.slippage,
        });
    }
    if (!allowStepUpdate) {
        throw new TransactionError(LifiErrorCode.SlippageNotMet, 'Slippage conditions not met!', getSlippageNotMetMessage(oldStep));
    }
    return statusManager.updateStepInRoute(newStep);
});
